const ServerInfoConstants = {
  GET_FAIL: 'WAL_SERVERINFO_GET_FAIL',
  GET_SUCCESS: 'WAL_SERVERINFO_GET_SUCCESS'
};

export default ServerInfoConstants;